import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const ModeEncore = () => (
  <ArticleWrapper articleId="mode_encore">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>Mode Encore</h1>
        <img src="/pictures/gallery/gallery6.JPG" alt="Mode Encore" className="rounded-lg mb-6" />
        {/* Add your Mode Encore article content here */}
      </div>
    </div>
  </ArticleWrapper>
);

export default ModeEncore;
